function adicionaClasse(el, classe) {
    el.classList.add(classe)
}

function removeClasse(el, classe) {
    el.classList.remove(classe)
}

// Imprimi o erro de validação de conteúdo
function imprimirErrorsConteudo(conteudo) {
    conteudo.forEach(textoValidacao => {
        toastr.warning(textoValidacao)
    });
}

// Cria o input com value PUT e retorna ele
function criarInputPut() {
    let inputPut = document.createElement('input')
    inputPut.setAttribute('type', 'hidden')
    inputPut.setAttribute('name', '_method')
    inputPut.setAttribute('value', 'PUT');
    return inputPut
}

function appendFormularioInput(formulario, input) {
    formulario.appendChild(input);
}


// Checa se precisa transform o formulário em um de cadastro;
function changeToUpdateForm(formulario, novoAjudaId) {

    if(formulario.querySelectorAll('input[value="PUT"]').length == 0) {
        let inputPut = criarInputPut()
        appendFormularioInput(formulario, inputPut)
        changeUrlUpdateForm(formulario, novoAjudaId)
    }
}

function changeUrlUpdateForm(formulario, novoAjudaId) {
    let newUrl = new String(formulario.dataset.urlUpdate)
    newUrl = newUrl.replace('var_id', novoAjudaId)
    formulario.action = newUrl;
}

// Salva a ajuda
function salvarAjuda(dados, formulario) {
    fetch(`${formulario.action}`, {
        method: 'POST',
        body: dados,
        headers: new Headers({
            'Accept': 'application/json'
        })
    }).then((response) => {

        if(response.ok ) {
            toastr.success('Ajuda salva');
            var contentType = response.headers.get("content-type");
            if(contentType && contentType.indexOf("application/json") !== -1) {
                response.json().then(data => {
                    console.log(data)
                    changeToUpdateForm(formulario, data.id);
                    
                }).catch(() => {
                    window.location.reload();
                });
            }
            
            
        } else {
            response.json().then(data => {
                imprimirErrorsConteudo(data.errors.conteudo)
            }).catch(() => {

                toastr.warning('Erro ao salvar')
            });
        }
        
    }).catch(() => {

        toastr.warning('Erro ao salvar')
    })
}


// Adiciona o evento de click no botão de salvar
function submitFormularioSalvarEvent(formulario) {

    formulario.addEventListener('submit', function (e) {
        e.preventDefault()
        let dadosFormulario = new FormData(formulario)
        if(!dadosFormulario.get('ativo')) {
            dadosFormulario.append('ativo', 0)
        } 
        salvarAjuda(dadosFormulario, formulario);
    })
}

// Inicializa animações
function initAnimacoes(botaoAcao) {
    
    setTimeout(function () {
        adicionaClasse(botaoAcao,'open')
    }, 4000);

    setTimeout(function () {
        removeClasse(botaoAcao,'fechado')
        removeClasse(botaoAcao,'open')
    }, 8000);
}

function init() {
    let formularioEdicao = document.getElementById('formularioAjudaPainel')
    let botaoAcao = document.getElementById('ajudaBotaoFixo')
    if(botaoAcao) {
        if(formularioEdicao) {
            submitFormularioSalvarEvent(formularioEdicao);
        }    
        initAnimacoes(botaoAcao);
    }
    
}

module.exports = {
    init
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/ajuda.js